import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Button from "../../../Components/UI/buttonGlobal";
import {
  postVehicles,
  showVehicles,
  updateVehicles,
} from "../../../MyApi/vehicles";
import { toast } from "react-toastify";
import i18next from "i18next";


const VechileModal = ({
  isOpen,
  toggle,
  refetch,
  modalId,
  modalMode,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    icon: null,
    logo: null,
    is_active: 1,
  });

  const lang = i18next.language;
  const [selectedCodeLang, setSelectedLangCode] = useState(lang);

  const languages = [
    { code: "ar", name: "العربية" },
    { code: "en", name: "English" },
  ];

  const { data, isLoading: showLoading } = useQuery(
    ["showvechile", modalId ,selectedCodeLang],
    () => showVehicles(modalId, selectedCodeLang),
    {
      enabled: !!modalId && (modalMode === "edit" || modalMode === "show")
    }
  );

  const vehicle = data?.data?.vehicle || {};

  useEffect(() => {
    if (modalMode === "edit") {
      setSelectedLangCode(lang);
    }
  }, []);


  const logoInputRef = useRef(null);

  const handleUploadClick = () => {
    logoInputRef.current?.click();
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "logo") {
      setFormData((prev) => ({ ...prev, logo: files[0] }));
    } else if (name === "selectedCodeLang") {
      setSelectedLangCode(value);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const mutation = useMutation({
    mutationKey: ["postVehicle"],
    mutationFn: (postData) => postVehicles(postData),
    onSuccess: (data) => {
      toast.success(data.message);
      toggle();
      refetch();
      resetForm();
    },
    onError: (error) => {
      if (error.response?.data?.errors) {
        toast.error(Object.values(error.response.data.errors).flat().join(', '));
      } else {
        toast.error(`${error.response?.data?.message || "حدث خطأ ما"}`);
      }
    },
  });

  const mutationUpdate = useMutation({
    mutationKey: ["updateVehicles"],
    mutationFn: (postData) => updateVehicles(postData, modalId),
    onSuccess: (data) => {
      toast.success(data.message);
      toggle();
      refetch();
    },
    onError: (error) => {
      if (error.response?.data?.errors) {
        toast.error(Object.values(error.response.data.errors).flat().join(', '));
      } else {
        toast.error(`${error.response?.data?.message || "حدث خطأ ما"}`);
      }
    },
  });

  const handleSubmit = () => {
    let fd = new FormData();
    fd.append("name", formData.name);
    fd.append("description", formData.description);
    if (formData.logo && formData.logo instanceof File) {
      fd.append("icon", formData.logo);
    }
    fd.append("is_active", Number(formData.is_active ));

    if (modalMode === "edit") {
      fd.append("_method", "PUT");
      fd.append("lang", selectedCodeLang);
      mutationUpdate.mutate(fd);
    } else {
      mutation.mutate(fd);
    }
  };


  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      icon: null,
      logo: null,
      is_active: 1,
    });
  };

  useEffect(() => {
    if ((modalMode === "edit" || modalMode === "show") && vehicle && Object.keys(vehicle).length > 0) {
      setFormData({
        name: vehicle.name || "",
        description: vehicle.description || "",
        logo: vehicle.icon || null,
        is_active: vehicle.is_active ?1 : 0,
     
      });
    }
  }, [vehicle, modalMode]);

  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const isDisabled = modalMode === "show";
  const isLoading =  mutation.isLoading || mutationUpdate.isLoading;

  const getModalTitle = () => {
    switch (modalMode) {
      case "edit":
        return "تعديل المركبة";
      case "show":
        return "عرض المركبة";
      default:
        return "إضافة مركبة جديدة";
    }
  };

  const getSubmitButtonLabel = () => {
    switch (modalMode) {
      case "edit":
        return "تعديل المركبة";
      default:
        return "إضافة المركبة";
    }
  };
console.log('formData', formData.logo)
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{getModalTitle()}</ModalHeader>
      <ModalBody className="add">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">اسم المركبة</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              disabled={isDisabled}
              placeholder="أدخل اسم المركبة"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">الوصف</label>
            <input
              type="text"
              name="description"
              className="form-control"
              value={formData.description}
              onChange={handleChange}
              disabled={isDisabled}
              placeholder="أدخل وصف المركبة"
            />
          </div>

          {modalMode === "edit" && (
            <div className="col-md-6 mb-3">
              <label className="form-label">اللغة</label>
              <select
                name="selectedCodeLang"
                className="form-select"
                value={selectedCodeLang}
                onChange={handleChange}
                disabled={isDisabled}
              >
                <option value="">اختر اللغة</option>
                {languages.map((language) => (
                  <option key={language.code} value={language.code}>
                    {language.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Upload Box */}
          <div className="col-12 mb-3">
            <div
              className={`flex-grow-1 border rounded-4 text-center p-4 upload-box ${isDisabled ? 'opacity-50' : ''}`}
              onClick={!isDisabled ? handleUploadClick : undefined}
              style={{ cursor: isDisabled ? "default" : "pointer", minWidth: "250px" }}
            >
              <h6 className="fw-bold mb-1">صورة المركبة</h6>
              <p className="text-muted small mb-0">
                (JPG / PNG) ارفع صورة بجودة عالية
              </p>
              <p className="text-muted small mb-0">الأبعاد 1:1</p>

              <input
                type="file"
                name="logo"
                accept="image/png, image/jpeg"
                ref={logoInputRef}
                hidden
                onChange={handleChange}
                disabled={isDisabled}
              />
              {formData.logo && (
                <img
                  src={
                    formData.logo instanceof File
                      ? URL.createObjectURL(formData.logo)
                      : formData.logo
                  }
                  alt=""
                  width={40}
                  height={40}
                  className="mt-2"
                />
              )}
              {formData.logo ? (
                <p className="mt-2 text-success">{formData.logo.name}</p>
              ) : (
                <p className="mt-2 text-muted">لا يوجد ملف مختار</p>
              )}
            </div>
          </div>
        </div>

        {modalMode !== "show" && (
          <div className="d-flex justify-content-start gap-2 mt-3">
            <Button
              className="btn-primary"
              label={getSubmitButtonLabel()}
              onClick={handleSubmit}
              isLoading={isLoading}
              disabled={isLoading}
            />
            <Button
              className="btn-white"
              label={"إلغاء"}
              onClick={toggle}
              disabled={isLoading}
            />
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default VechileModal;
